function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export var breakpoints = {
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440
};
export var gutters = {
  xsmall: {
    width: 15,
    security: 0
  },
  small: {
    width: 15,
    security: 0
  },
  medium: {
    width: 15,
    security: 12
  },
  large: {
    width: 15,
    security: 32
  },
  xlarge: {
    width: 15,
    security: 40
  },
  xxlarge: {
    width: 15,
    security: 45
  }
};
export var colors = {
  black: '#000',
  white: '#FFF',
  primary: '#FF7900',
  primaryDark: '#F16E00',
  grey1: '#333',
  grey2: '#F4F4F4',
  grey3: '#555',
  grey4: '#DDD',
  text: '#000',
  invertedText: '#FFF',
  transparent: 'transparent',
  success: '#3DE35A',
  error: '#E70002',
  info: '#26B2FF',
  alert: '#FFCD0B',
  dimmedSuccess: '#EBFCEE',
  dimmedError: '#FCE5E5',
  dimmedInfo: '#E9F7FF',
  dimmedAlert: '#FFFAE6'
};
var textCommon = {
  maxWidth: 600,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
};
export var text = {
  lead: {
    small: _extends({}, textCommon, {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10
    }),
    medium: _extends({}, textCommon, {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10
    }),
    large: _extends({}, textCommon, {
      fontSize: 18,
      lineHeight: 24,
      paddingTop: 6,
      paddingBottom: 10
    })
  },
  standard: {
    small: _extends({}, textCommon, {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10
    }),
    medium: _extends({}, textCommon, {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10
    }),
    large: _extends({}, textCommon, {
      fontSize: 16,
      lineHeight: 22,
      paddingTop: 7,
      paddingBottom: 10
    })
  },
  mention: {
    small: _extends({}, textCommon, {
      fontSize: 12,
      lineHeight: 18,
      paddingTop: 8,
      paddingBottom: 11
    }),
    medium: _extends({}, textCommon, {
      fontSize: 12,
      lineHeight: 18,
      paddingTop: 8,
      paddingBottom: 11
    }),
    large: _extends({}, textCommon, {
      fontSize: 14,
      lineHeight: 20,
      paddingTop: 8,
      paddingBottom: 10
    })
  }
};
export var button = {
  common: {
    fontSize: text.standard.large.fontSize,
    lineHeight: text.standard.large.lineHeight,
    maxWidth: 300,
    borderWidth: 1,
    spaceBetween: 30,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0,
    paddingTop: 13,
    paddingBottom: 13,
    paddingLeft: 45,
    paddingRight: 45
  },
  primary: {
    normal: {
      "default": {
        backgroundColor: colors.primaryDark,
        borderColor: colors.primaryDark,
        color: colors.invertedText
      },
      hover: {
        backgroundColor: colors.black,
        borderColor: colors.black,
        color: colors.invertedText
      },
      active: {
        backgroundColor: colors.white,
        borderColor: colors.black,
        color: colors.text
      },
      disabled: {
        backgroundColor: colors.grey4,
        borderColor: colors.grey4,
        color: colors.invertedText
      },
      loading: {
        backgroundColor: colors.white,
        borderColor: colors.grey4,
        color: colors.grey4
      }
    },
    inverse: {
      "default": {
        backgroundColor: colors.primaryDark,
        borderColor: colors.primaryDark,
        color: colors.invertedText
      },
      hover: {
        backgroundColor: colors.white,
        borderColor: colors.white,
        color: colors.text
      },
      active: {
        backgroundColor: colors.black,
        borderColor: colors.white,
        color: colors.invertedText
      },
      disabled: {
        backgroundColor: colors.grey3,
        borderColor: colors.grey3,
        color: colors.text
      },
      loading: {
        backgroundColor: colors.white,
        borderColor: colors.grey3,
        color: colors.grey3
      }
    }
  },
  secondary: {
    normal: {
      "default": {
        backgroundColor: colors.transparent,
        borderColor: colors.black,
        color: colors.text
      },
      hover: {
        backgroundColor: colors.black,
        borderColor: colors.black,
        color: colors.invertedText
      },
      active: {
        backgroundColor: colors.transparent,
        borderColor: colors.primaryDark,
        color: colors.primaryDark
      },
      disabled: {
        backgroundColor: colors.transparent,
        borderColor: colors.grey4,
        color: colors.grey4
      },
      loading: {
        backgroundColor: colors.white,
        borderColor: colors.grey4,
        color: colors.grey4
      }
    },
    inverse: {
      "default": {
        backgroundColor: colors.transparent,
        borderColor: colors.white,
        color: colors.invertedText
      },
      hover: {
        backgroundColor: colors.white,
        borderColor: colors.white,
        color: colors.text
      },
      active: {
        backgroundColor: colors.transparent,
        borderColor: colors.primary,
        color: colors.primary
      },
      disabled: {
        backgroundColor: colors.transparent,
        borderColor: colors.grey3,
        color: colors.grey3
      },
      loading: {
        backgroundColor: colors.white,
        borderColor: colors.grey3,
        color: colors.grey3
      }
    }
  },
  image: {
    normal: {
      "default": {
        backgroundColor: colors.black,
        borderColor: colors.black,
        color: colors.invertedText
      },
      hover: {
        backgroundColor: colors.primaryDark,
        borderColor: colors.primaryDark,
        color: colors.invertedText
      },
      active: {
        backgroundColor: colors.transparent,
        borderColor: colors.primaryDark,
        color: colors.primaryDark
      },
      disabled: {
        backgroundColor: colors.grey4,
        borderColor: colors.grey4,
        color: colors.invertedText
      }
    },
    inverse: {
      "default": {
        backgroundColor: colors.white,
        borderColor: colors.white,
        color: colors.text
      },
      hover: {
        backgroundColor: colors.primaryDark,
        borderColor: colors.primaryDark,
        color: colors.invertedText
      },
      active: {
        backgroundColor: colors.transparent,
        borderColor: colors.primary,
        color: colors.primary
      },
      disabled: {
        backgroundColor: colors.grey3,
        borderColor: colors.grey3,
        color: colors.text
      }
    }
  }
};
var headingCommon = {
  fontSize: 14,
  lineHeight: 16,
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  maxWidth: 600
};
export var breadcrumb = {
  height: 38,
  paddingTop: 8,
  paddingBottom: 10,
  small: {
    paddingLeft: 15,
    paddingRight: 15
  },
  medium: {
    paddingLeft: 27,
    paddingRight: 27
  },
  xlarge: {
    paddingLeft: 55,
    paddingRight: 55
  },
  item: {
    height: 20,
    fontSize: 14,
    lineHeight: 1.43,
    padding: 0,
    marginLeft: 21,
    firstChild: {
      marginLeft: 0
    },
    svg: {
      width: 7,
      height: 12,
      top: 5,
      left: -14
    }
  }
};
export var heading = {
  h1: {
    small: _extends({}, headingCommon, {
      fontSize: 26,
      lineHeight: 30,
      paddingTop: 4,
      paddingBottom: 10
    }),
    medium: _extends({}, headingCommon, {
      fontSize: 34,
      lineHeight: 40,
      paddingBottom: 8
    }),
    large: _extends({}, headingCommon, {
      fontSize: 42,
      lineHeight: 50,
      paddingBottom: 6
    })
  },
  h2: {
    small: _extends({}, headingCommon, {
      fontSize: 24,
      lineHeight: 28,
      marginTop: 5,
      paddingBottom: 16,
      underlineWidth: 30,
      underlineHeight: 6
    }),
    medium: _extends({}, headingCommon, {
      fontSize: 30,
      lineHeight: 34,
      paddingBottom: 15,
      underlineWidth: 30,
      underlineHeight: 6
    }),
    large: _extends({}, headingCommon, {
      fontSize: 34,
      lineHeight: 40,
      paddingBottom: 14,
      underlineWidth: 30,
      underlineHeight: 6
    })
  },
  h3: {
    small: _extends({}, headingCommon, {
      fontSize: 20,
      lineHeight: 24,
      paddingTop: 5,
      paddingBottom: 11
    }),
    medium: _extends({}, headingCommon, {
      fontSize: 26,
      lineHeight: 30,
      paddingTop: 4,
      paddingBottom: 10
    }),
    large: _extends({}, headingCommon, {
      fontSize: 30,
      lineHeight: 34,
      paddingTop: 3,
      paddingBottom: 9
    })
  },
  h4: {
    small: _extends({}, headingCommon, {
      fontSize: 20,
      lineHeight: 24,
      paddingTop: 5,
      paddingBottom: 11
    }),
    medium: _extends({}, headingCommon, {
      fontSize: 22,
      lineHeight: 26,
      paddingTop: 6,
      paddingBottom: 10
    }),
    large: _extends({}, headingCommon, {
      fontSize: 26,
      lineHeight: 30,
      paddingTop: 4,
      paddingBottom: 10
    })
  },
  h5: {
    small: _extends({}, headingCommon),
    medium: _extends({}, headingCommon),
    large: _extends({}, headingCommon)
  },
  h6: {
    small: _extends({}, headingCommon),
    medium: _extends({}, headingCommon),
    large: _extends({}, headingCommon)
  }
};
export var input = {
  paddingTop: 35,
  paddingBottom: 13,
  paddingLeft: 0,
  paddingRight: 15,
  maxWidth: 450,
  label: {
    "default": {
      fontSize: 16,
      lineHeight: 22,
      color: colors.grey3
    },
    hover: {
      color: colors.black
    },
    focus: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.black
    },
    error: {
      color: colors.error
    }
  },
  icon: {
    size: 24
  },
  field: {
    fontSize: 16,
    lineHeight: 22,
    backgroundColor: colors.white,
    color: colors.text,
    "default": {
      borderWidth: 1,
      borderColor: colors.grey3
    },
    hover: {
      borderColor: colors.black
    },
    focus: {
      borderWidth: 2,
      borderColor: colors.black
    },
    error: {
      borderWidth: 2,
      borderColor: colors.error
    }
  },
  helper: {
    paddingTop: 8,
    paddingBottom: 0,
    fontSize: 14,
    lineHeight: 20,
    color: colors.grey3
  },
  error: {
    paddingTop: 8,
    paddingBottom: 10,
    fontSize: 14,
    lineHeight: 20,
    color: colors.black,
    backgroundColor: colors.dimmedError,
    icon: {
      size: 20,
      color: 'error',
      marginLeft: 15,
      marginRight: 15
    }
  }
};
export var textarea = {
  marginTop: 34,
  mobile: {
    svg: {
      marginLeft: 15,
      marginRight: 15
    }
  },
  label: {
    height: 24,
    fontSize: 16,
    lineHeight: 1.38,
    icon: {
      marginRight: 15,
      marginLeft: 15,
      width: 24,
      height: 24,
      filled: {
        top: 45,
        right: 16
      }
    },
    active: {
      lineHeight: 1.43,
      fontSize: 14,
      height: 20
    },
    mobile: {
      marginTop: 12
    },
    error: {
      lineHeight: 1.38,
      fontSize: 16
    }
  },
  spacer: {
    height: 1,
    marginTop: 13,
    marginBottom: 8,
    active: {
      height: 2
    },
    error: {
      height: 2,
      marginTop: 12,
      marginBottom: 8
    }
  },
  helper: {
    height: 20,
    fontSize: 14,
    lineHeight: 1.43,
    icon: {
      marginBottom: 10
    },
    svg: {
      marginRight: 15
    },
    mobile: {
      marginTop: 8,
      marginBottom: 10
    }
  },
  fakeTextarea: {
    marginTop: 3,
    height: 1.38 * 16 * 3,
    paddingRight: 54,
    fontSize: 16,
    lineHeight: 1.38
  },
  textarea: {
    marginTop: 3,
    paddingRight: 15,
    height: 198,
    fontSize: 16,
    lineHeight: 1.38,
    mobile: {
      marginBottom: 12,
      subHeight: 12 + 20 + 3 + 13 + 8 + 20 + 10
    }
  },
  error: {
    svg: {
      marginLeft: 15,
      marginRight: 15
    }
  }
};
export var modal = {
  small: {
    width: '100%',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 15,
    paddingRight: 15
  },
  medium: {
    width: 10 / 12,
    paddingTop: 45,
    paddingBottom: 45,
    paddingLeft: 45,
    paddingRight: 75
  },
  xlarge: {
    width: 8 / 12,
    paddingTop: 45,
    paddingBottom: 45,
    paddingLeft: 60,
    paddingRight: 75
  }
};
export var checkbox = {
  size: 24,
  checked: 'primaryDark',
  unchecked: 'black',
  disabled: 'grey4'
};
export var radio = {
  size: 24,
  checked: 'primaryDark',
  unchecked: 'black',
  disabled: 'grey4'
};
export var formControl = {
  labelMaxLines: 2,
  sublabelMaxLines: 2,
  paddingTop: 12,
  paddingBottom: 12,
  paddingLeft: 15,
  labelSpacer: 3,
  label: {
    "default": {
      fontSize: 16,
      lineHeight: 22,
      color: colors.black
    },
    hover: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.black
    },
    focus: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.black
    },
    disabled: {
      fontSize: 16,
      lineHeight: 22,
      color: colors.grey4
    }
  },
  sublabel: {
    "default": {
      fontSize: 14,
      lineHeight: 20,
      color: colors.grey3
    },
    hover: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.grey3
    },
    focus: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.grey3
    },
    disabled: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.grey4
    }
  }
};
export var calendar = {
  month: {
    fontSize: text.standard.large.fontSize,
    lineHeight: text.standard.large.lineHeight,
    marginTop: 7,
    marginBottom: 17,
    marginLeft: 0,
    marginRight: 0
  },
  daysName: {
    fontSize: text.standard.large.fontSize,
    lineHeight: text.standard.large.lineHeight,
    color: colors.grey3,
    marginTop: 0,
    marginBottom: 10,
    marginLeft: 0,
    marginRight: 0
  },
  day: {
    fontSize: text.standard.large.fontSize,
    lineHeight: text.standard.large.lineHeight,
    width: 38,
    height: 35,
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 4,
    hover: {
      color: colors.invertedText,
      backgroundColor: colors.black
    },
    active: {
      color: colors.invertedText,
      backgroundColor: colors.primaryDark
    },
    disabled: {
      color: colors.grey4,
      backgroundColor: colors.white
    }
  }
};
export var accordion = {
  borderWidth: 1,
  borderColor: colors.black,
  title: {
    marginRight: 15,
    maxLines: 2
  },
  header: {
    small: {
      height: 70
    },
    medium: {
      height: 80
    },
    large: {
      height: 90
    }
  },
  icon: {
    small: {
      size: 32,
      marginRight: 15
    },
    medium: {
      size: 42,
      marginRight: 20
    },
    large: {
      size: 52,
      marginRight: 30
    }
  },
  arrow: {
    small: {
      size: 14
    },
    medium: {
      size: 21
    },
    large: {
      size: 25
    }
  },
  content: {
    small: {
      paddingBottom: 15
    },
    medium: {
      paddingBottom: 30
    },
    large: {
      paddingBottom: 30
    }
  }
};
export var alert = {
  standard: {
    container: {
      paddingLeft: 15,
      paddingRight: 15
    },
    icon: {
      size: 32
    },
    title: {
      paddingTop: 19,
      paddingBottom: 21,
      paddingLeft: 15
    },
    text: {
      paddingTop: 0,
      paddingBottom: 30
    },
    button: {
      paddingBottom: 30
    }
  },
  mini: {
    container: {
      paddingLeft: 15,
      paddingRight: 15
    },
    icon: {
      size: 20
    },
    title: {
      withoutLink: {
        paddingTop: 8,
        paddingBottom: 10,
        paddingLeft: 15
      },
      withLink: {
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 15
      }
    },
    text: {
      paddingTop: 0,
      paddingBottom: 10
    },
    button: {
      paddingBottom: 10
    }
  }
};
export var arrowLink = {
  maxWidth: 300,
  standard: {
    paddingTop: 7,
    paddingBottom: 10,
    icon: {
      size: 12,
      color: 'primaryDark',
      margin: 10
    }
  },
  mini: {
    paddingTop: 8,
    paddingBottom: 10,
    icon: {
      size: 10,
      color: 'primaryDark',
      margin: 7
    }
  }
};